import { css } from 'aphrodite';
import * as React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { TextInput } from '../../../../../../../../web/components/TextInput';
import { styleSheet } from '../styles';
import { ErrorMessage } from './ErrorMessage';

interface AttendeeInfoFieldsProps {
	requirePhoneNumber?: boolean;
}

export const AttendeeInfoFields: React.FC<AttendeeInfoFieldsProps> = ({ requirePhoneNumber = false }) => {
	const {
		control,
		formState: { isSubmitted, errors },
	} = useFormContext();

	return (
		<div className={css(styleSheet.rsvpInfo)}>
			<div className={css(styleSheet.formControl)}>
				<label htmlFor='client-firstName' className={css(styleSheet.label)}>
					First Name <span className={css(styleSheet.required)}>*</span>
				</label>
				<Controller
					name='firstName'
					control={control}
					render={({ field: { ref, ...fieldProps } }) => (
						<TextInput inputId='client-firstName' name='firstName' type='text' {...fieldProps} />
					)}
				/>
				{isSubmitted && errors.firstName && <ErrorMessage message={errors.firstName.message} />}
			</div>

			<div className={css(styleSheet.formControl)}>
				<label htmlFor='client-lastName' className={css(styleSheet.label)}>
					Last Name <span className={css(styleSheet.required)}>*</span>
				</label>
				<Controller
					name='lastName'
					control={control}
					render={({ field: { ref, ...fieldProps } }) => (
						<TextInput inputId='client-lastName' name='lastName' type='text' {...fieldProps} />
					)}
				/>
				{isSubmitted && errors.lastName && <ErrorMessage message={errors.lastName.message} />}
			</div>

			<div className={css(styleSheet.formControl)}>
				<label htmlFor='client-email' className={css(styleSheet.label)}>
					Email <span className={css(styleSheet.required)}>*</span>
				</label>
				<Controller
					name='email'
					control={control}
					render={({ field: { ref, ...fieldProps } }) => (
						<TextInput inputId='client-email' type='text' {...fieldProps} />
					)}
				/>
				{isSubmitted && errors.email && <ErrorMessage message={errors.email.message} />}
			</div>

			<div className={css(styleSheet.formControl)}>
				<label htmlFor='client-phone' className={css(styleSheet.label)}>
					Phone{' '}
					{!requirePhoneNumber ? (
						<small style={{ fontSize: 11 }}>(Optional)</small>
					) : (
						<span className={css(styleSheet.required)}>*</span>
					)}
				</label>
				<Controller
					name='phone'
					control={control}
					render={({ field: { ref, ...fieldProps } }) => (
						<TextInput inputId='client-phone' type='text' {...fieldProps} placeholder='(999)999-9999' />
					)}
				/>
				{isSubmitted && errors.phone && <ErrorMessage message={errors.phone.message} />}
			</div>
		</div>
	);
};
